module.exports = __webpack_public_path__ + "static/media/resume.11b2f6e2.pdf";